import Jitsi from './JitsiView'
export default Jitsi
